import { render, staticRenderFns } from "./OutbreakSetup.vue?vue&type=template&id=780a977b&scoped=true&"
import script from "./OutbreakSetup.vue?vue&type=script&lang=js&"
export * from "./OutbreakSetup.vue?vue&type=script&lang=js&"
import style0 from "./OutbreakSetup.vue?vue&type=style&index=0&id=780a977b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a977b",
  null
  
)

export default component.exports